module.exports = __webpack_public_path__ + "img/128-Silicia STFN Mat.jpg";